import { useState, useEffect, useRef } from 'react';
import { getProjestsFiledsListApi } from '@services/Selection';
import { Checkbox, InputNumber, Button, Input, Modal, Form, Switch, Space } from 'antd';
import './FieldsList.less';
import { getTopicsSelectedInfoApi } from '@services/Selection';
import { useCallback } from 'react';

// 联系人信息二级申报字段
const secondField = [
    { field_name: 'name', field_display_name: '姓名' },
    { field_name: 'phone', field_display_name: '手机号' },
    { field_name: 'department', field_display_name: '科室部门' },
    { field_name: 'post', field_display_name: '职务' },
    { field_name: 'title', field_display_name: '职称' },
    { field_name: 'email', field_display_name: '电子邮箱' },
];

// 人物类实践二级申报字段
const personSecondField = [
    { field_name: 'phone', field_display_name: '手机号' },
    { field_name: 'department', field_display_name: '科室部门' },
    { field_name: 'post', field_display_name: '职务' },
    { field_name: 'title', field_display_name: '职称' },
    { field_name: 'email', field_display_name: '电子邮箱' },
];

const formItemLayout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 18 },
};

/** 将接口或 JSON 中的值转为 InputNumber 可用的数字，空值用 undefined 以便正确回显 */
const toFormNumber = v => {
    if (v === null || v === undefined || v === '') {
        return undefined;
    }
    const n = Number(v);
    return Number.isNaN(n) ? undefined : n;
};

/**
 * 将 getTopicSelectedFields 里已保存的一条 caseField 合并到 getFields 返回的模板上。
 * 必须按 fieldName 在全部类目数组中查找，不能写死 Object.values(resData)[0/1/2]（与接口字段顺序可能不一致）。
 */
const mergeSavedCaseFieldIntoTemplate = (resData, saved) => {
    for (const arr of Object.values(resData)) {
        if (!Array.isArray(arr)) {
            continue;
        }
        for (const el of arr) {
            if (el.fieldName !== saved.field_name) {
                continue;
            }
            el.required = saved.required;
            el.field_display_name = saved.field_display_name;
            if (saved.pid === 1) {
                el.field_desc = saved.field_desc;
                if (el.fieldName === 'person_case_info') {
                    el.children = saved.children;
                }
                if (el.isDefault !== 1) {
                    el.isDefault = 2;
                }
            } else if (saved.pid === 2) {
                el.field_desc = saved.field_desc;
                el.attachment_max_file_size = saved.attachment_max_file_size;
                el.attachment_max_count = saved.attachment_max_count;
                el.attachment_type = saved.attachment_type;
                if (el.isDefault !== 1) {
                    el.isDefault = 2;
                }
            } else if (saved.pid === 3) {
                el.field_desc = saved.field_desc;
                el.children = saved.children;
                if (el.isDefault !== 1) {
                    el.isDefault = 2;
                }
            }
            return;
        }
    }
};

const FieldsList = props => {
    const { topicId, allFields, setAllFields, fieldsSelect, setFieldsSelect } = props;

    const [fieles, setFieles] = useState([]);
    const [fieldDisplayModal, setFieldDisplayModal] = useState(false);
    const [fieldDisplay] = Form.useForm();
    const currentField = useRef(); // 当前编辑的自定义说明 - 字段
    const [currentFieldData, setCurrentFieldData] = useState(false); // 当前编辑 - 字段

    const getFiled = (e, item) => {
        if (item.fieldName === 'contacts' && !e.target.checked) {
            return;
        }
        if (item.cateId === 1) {
            const firstFieles = [...fieles];
            const changeIndex = fieles[0].findIndex(it => it.id === item.id);
            firstFieles[0][changeIndex].required = e.target.checked ? true : '';
            firstFieles[0][changeIndex].isDefault = e.target.checked ? 2 : 0;
            setFieles([...firstFieles]);
        } else if (item.cateId === 2) {
            const firstFieles = [...fieles];
            const changeIndex = fieles[1].findIndex(it => it.id === item.id);
            firstFieles[1][changeIndex].required = e.target.checked ? true : '';
            firstFieles[1][changeIndex].isDefault = e.target.checked ? 2 : 0;
            setFieles([...firstFieles]);
        } else if (item.cateId === 3) {
            const firstFieles = [...fieles];
            const changeIndex = fieles[2].findIndex(it => it.id === item.id);
            firstFieles[2][changeIndex].required = e.target.checked ? true : '';
            firstFieles[2][changeIndex].isDefault = e.target.checked ? 2 : 0;
            setFieles([...firstFieles]);
        }
        let allSelect = [...fieldsSelect];
        let all = [...allFields];
        const fieldKey = item.fieldName;
        const displayName = item.displayName;
        const index = allSelect.findIndex(it => it.value === fieldKey);
        if (index > -1) {
            allSelect = allSelect.filter(it => it.value !== fieldKey);
            all = all.filter(its => its.field_name !== fieldKey);
            setFieldsSelect([...allSelect]);
            setAllFields([...all]);
        } else {
            allSelect.push({ value: fieldKey, name: displayName });
            all.push({ field_name: fieldKey, required: true, pid: item.cateId });
            setFieldsSelect([...allSelect]);
            setAllFields([...all]);
        }
    };

    const getItem = (e, item) => {
        if (item.fieldName === 'contacts' && !e) {
            return;
        }
        if (item.cateId === 1) {
            const firstFieles = [...fieles];
            const changeIndex = fieles[0].findIndex(it => it.id === item.id);
            firstFieles[0][changeIndex].required = e ? 1 : 0;
            setFieles([...firstFieles]);
        } else if (item.cateId === 2) {
            const firstFieles = [...fieles];
            const changeIndex = fieles[1].findIndex(it => it.id === item.id);
            firstFieles[1][changeIndex].required = e ? 1 : 0;
            setFieles([...firstFieles]);
        } else if (item.cateId === 3) {
            const firstFieles = [...fieles];
            const changeIndex = fieles[2].findIndex(it => it.id === item.id);
            firstFieles[2][changeIndex].required = e ? 1 : 0;
            setFieles([...firstFieles]);
        }
        const all = [...allFields];
        // if(fieldsSelect.findIndex(it=>it.field_name === e.target.name)>-1){
        if (allFields.findIndex(it => it.field_name === item.fieldName) > -1) {
            all[allFields.findIndex(it => it.field_name === item.fieldName)].required = e ? 1 : 0;
            setAllFields([...all]);
        }
        // }
    };

    // 编辑
    const fieldEdit = (e, item) => {
        console.log(item);
        e.stopPropagation();
        const saved = allFields.find(af => af.field_name === item.fieldName);
        const values = {
            displayName: item.displayName,
            field_display_name: saved?.field_display_name ?? item.field_display_name,
            field_desc: saved?.field_desc ?? item.field_desc,
            attachment_max_file_size: toFormNumber(saved?.attachment_max_file_size ?? item.attachment_max_file_size),
            attachment_max_count: toFormNumber(saved?.attachment_max_count ?? item.attachment_max_count),
            attachment_type: saved?.attachment_type ?? item.attachment_type,
            children: saved?.children ?? item.children,
        };
        currentField.current = item;
        setCurrentFieldData(item);
        setFieldDisplayModal(true);
        // 等条件渲染的 Form.Item 挂载后再 setFieldsValue，否则 attachment_max_file_size 等项无法回显
        setTimeout(() => {
            fieldDisplay.setFieldsValue(values);
        }, 0);
    };

    // 自定义保存
    const fieldDisplayOk = () => {
        fieldDisplay.validateFields().then(values => {
            console.log(values);
            const curItem = currentField.current;
            if (curItem?.cateId) {
                const firstFieles = [...fieles];
                const indx = curItem.cateId - 1;
                const changeIndex = fieles[indx].findIndex(it => it.id === curItem.id);
                firstFieles[indx][changeIndex].field_display_name = values.field_display_name;
                firstFieles[indx][changeIndex].field_desc = values.field_desc;
                firstFieles[indx][changeIndex].attachment_max_file_size = values.attachment_max_file_size;
                firstFieles[indx][changeIndex].attachment_max_count = values.attachment_max_count;
                firstFieles[indx][changeIndex].attachment_type = values.attachment_type;
                firstFieles[indx][changeIndex].children = values.children;
                setFieles([...firstFieles]);

                const secondLevelRefFields = curItem.fieldName === 'person_case_info' ? personSecondField : secondField;
                let all = [...allFields];
                all = all.map(its => {
                    const newIts = { ...its };
                    if (its.field_name === curItem.fieldName) {
                        newIts.field_display_name = values.field_display_name;
                        newIts.field_desc = values.field_desc;
                        newIts.attachment_max_file_size = values.attachment_max_file_size;
                        newIts.attachment_max_count = values.attachment_max_count;
                        newIts.attachment_type = values.attachment_type;
                        newIts.children =
                            values.children && values.children.length
                                ? values.children.map((it, index) => {
                                      const ref = secondLevelRefFields[index];
                                      return {
                                          ...it,
                                          field_name: ref?.field_name ?? it?.field_name,
                                          field_display_name: ref?.field_display_name ?? it?.field_display_name,
                                      };
                                  })
                                : undefined;
                    }
                    return newIts;
                });
                setAllFields([...all]);
            }

            setFieldDisplayModal(false);
        });
    };

    const fieldDisplayCancel = () => {
        fieldDisplay.resetFields();
        setFieldDisplayModal(false);
    };

    const FirstFieles = useCallback(() => {
        return fieles[0]?.map((item, index) => (
            <div className="fieles-choice" key={item.id}>
                <Checkbox checked={item.isDefault === 1 || item.isDefault === 2} onChange={e => getFiled(e, item)} value={item.fieldName} checkname={item.displayName} disabled={item.isDefault === 1}>
                    {item.displayName}
                </Checkbox>
                <div className="field-name">{item.field_display_name || '-'}</div>
                <div className="field-description">{item.field_desc || '-'}</div>
                <div className="field-required">
                    是否必填：
                    <Switch checkedChildren="必填" unCheckedChildren="非必填" checked={item.required} onChange={e => getItem(e, item)} />
                </div>
                <Button type="link" onClick={e => fieldEdit(e, item)} disabled={!item.isDefault}>
                    编辑
                </Button>
            </div>
        ));
    }, [fieles]);

    const SecondFieles = useCallback(() => {
        return fieles[2]?.map((item, index) => (
            <div className="fieles-choice" key={item.id}>
                <Checkbox checked={item.isDefault === 1 || item.isDefault === 2 || item.fieldName === 'contacts'} disabled={item.isDefault === 1 || item.fieldName === 'contacts'} onChange={e => getFiled(e, item)} value={item.fieldName} checkname={item.displayName}>
                    {item.displayName}
                </Checkbox>
                <div className="field-name">{item.field_display_name || '-'}</div>
                <div className="field-description">{item.field_desc || '-'}</div>
                <div className="field-required">
                    是否必填：
                    <Switch checkedChildren="必填" unCheckedChildren="非必填" checked={item.fieldName === 'contacts' ? true : item.required} disabled={item.isDefault === 1 || item.fieldName === 'contacts'} onChange={e => getItem(e, item)} />
                </div>
                <Button type="link" onClick={e => fieldEdit(e, item)} disabled={!item.isDefault}>
                    编辑
                </Button>
            </div>
        ));
    }, [fieles]);

    const ThirddFieles = useCallback(() => {
        return fieles[1]?.map((item, index) => (
            <div className="fieles-choice" key={item.id}>
                <Checkbox checked={item.isDefault === 1 || item.isDefault === 2} disabled={item.isDefault === 1} onChange={e => getFiled(e, item)} value={item.fieldName} checkname={item.displayName}>
                    {item.displayName}
                </Checkbox>
                <div className="field-name">{item.field_display_name || '-'}</div>
                <div className="field-description">{item.field_desc || '-'}</div>
                <div className="field-required">
                    是否必填：
                    <Switch checkedChildren="必填" unCheckedChildren="非必填" checked={item.required} onChange={e => getItem(e, item)} />
                </div>
                <Button type="link" onClick={e => fieldEdit(e, item)} disabled={!item.isDefault}>
                    编辑
                </Button>
            </div>
        ));
    }, [fieles]);

    useEffect(() => {
        getProjestsFiledsListApi().then(res => {
            if (res.status_code === 200) {
                const firstArr = Object.values(res.data)[0].filter(item => item.isDefault === 1);
                Object.values(res.data)[0].forEach(el => {
                    if (el.isDefault === 1) {
                        el.required = true;
                    }
                });
                const secondArr = Object.values(res.data)[1].filter(item => item.isDefault === 1);
                Object.values(res.data)[1].forEach(el => {
                    if (el.isDefault === 1) {
                        el.required = true;
                    }
                });
                const thirdArr = Object.values(res.data)[2].filter(item => item.isDefault === 1 || item.fieldName === 'contacts');
                Object.values(res.data)[2].forEach(el => {
                    if (el.isDefault === 1 || el.fieldName === 'contacts') {
                        el.required = true;
                    }
                    if (el.fieldName === 'contacts' && el.isDefault !== 1) {
                        el.isDefault = 2;
                    }
                });
                const final = firstArr
                    .concat(secondArr)
                    .concat(thirdArr)
                    .map(item => {
                        return { field_name: item.fieldName, required: true, pid: item.cateId };
                    });
                getTopicsSelectedInfoApi({ topicId }).then(select => {
                    if (select.status_code === 200) {
                        if (select.data) {
                            const caseFields = JSON.parse(select.data.caseFields);
                            caseFields.forEach(saved => {
                                mergeSavedCaseFieldIntoTemplate(res.data, saved);
                            });
                            for (const arr of Object.values(res.data)) {
                                if (!Array.isArray(arr)) {
                                    continue;
                                }
                                for (const el of arr) {
                                    if (el.fieldName === 'contacts') {
                                        el.required = true;
                                        if (el.isDefault !== 1) {
                                            el.isDefault = 2;
                                        }
                                    }
                                }
                            }
                        }
                        if (!select.data || JSON.parse(select.data.caseFields).length == 0) {
                            setAllFields([...final]);
                            const selects = final.map(item => {
                                return { value: item.field_name };
                            });
                            setFieldsSelect([...selects]);
                        } else {
                            let parsedFields = JSON.parse(select.data.caseFields);
                            const contactsMeta = Object.values(res.data)[2].find(el => el.fieldName === 'contacts');
                            if (contactsMeta) {
                                parsedFields = parsedFields.map(it => (it.field_name === 'contacts' ? { ...it, required: true, pid: 3 } : it));
                                if (!parsedFields.some(it => it.field_name === 'contacts')) {
                                    parsedFields.push({
                                        field_name: 'contacts',
                                        required: true,
                                        pid: 3,
                                        field_display_name: contactsMeta.field_display_name,
                                        field_desc: contactsMeta.field_desc,
                                    });
                                }
                            }
                            setAllFields(parsedFields);
                            const selects = parsedFields.map(item => {
                                return { value: item.field_name };
                            });
                            setFieldsSelect([...selects]);
                        }
                        setFieles(Object.values(res.data));
                    }
                });
            }
        });
    }, [topicId]);

    const geta = res => {
        console.log(res);
    };

    return (
        <div className="fields-list-container">
            <div className="field-list-table-title">
                <span>默认字段名</span>
                <span>自定义字段名</span>
                <span>自定义字段说明</span>
                <span>是否必填</span>
                <span>操作</span>
            </div>

            <div>基础信息</div>
            {fieles[0] && <FirstFieles />}

            <div>联系人信息</div>
            {fieles[2] && <SecondFieles />}

            <div>实践上传</div>
            {fieles[2] && <ThirddFieles />}

            <Modal title="编辑" centered open={fieldDisplayModal} onOk={fieldDisplayOk} onCancel={fieldDisplayCancel} width={700}>
                <Form form={fieldDisplay} autoComplete="off" {...formItemLayout}>
                    <Form.Item label="默认字段名：" name="displayName">
                        <Input disabled />
                    </Form.Item>

                    <Form.Item label="自定义字段名：" name="field_display_name" rules={[{ required: true, message: '请输入自定义字段名' }]}>
                        <Input placeholder="请输入自定义字段名" maxLength={10} showCount />
                    </Form.Item>

                    {currentFieldData && (
                        <Form.Item label="自定义字段说明：" name="field_desc">
                            <Input.TextArea rows={4} placeholder="请输入自定义字段说明" maxLength={100} showCount />
                        </Form.Item>
                    )}

                    {currentFieldData && (currentFieldData.fieldName === 'doc' || currentFieldData.fieldName === 'certificates') && (
                        <Form.Item label="支持文件格式：" name="attachment_type" rules={[{ required: true, message: '请选择文件格式' }]}>
                            <Checkbox.Group style={{ width: '100%' }}>
                                <Space wrap size={[8, 8]} style={{ width: '100%' }}>
                                    <Checkbox value="PPT">PPT</Checkbox>
                                    <Checkbox value="PPTX">PPTX</Checkbox>
                                    <Checkbox value="DOC">DOC</Checkbox>
                                    <Checkbox value="DOCX">DOCX</Checkbox>
                                    <Checkbox value="PDF">PDF</Checkbox>
                                    {currentFieldData && currentFieldData.fieldName === 'certificates' && (
                                        <>
                                            <Checkbox value="XLS">XLS</Checkbox>
                                            <Checkbox value="XLSX">XLSX</Checkbox>
                                            <Checkbox value="ZIP">ZIP</Checkbox>
                                            <Checkbox value="RAR">RAR</Checkbox>
                                            <Checkbox value="PNG">PNG</Checkbox>
                                            <Checkbox value="JPG">JPG</Checkbox>
                                        </>
                                    )}
                                </Space>
                            </Checkbox.Group>
                        </Form.Item>
                    )}

                    {currentFieldData && currentFieldData.fieldName === 'certificates' && (
                        <Form.Item label="总文件上传数量：" required>
                            <Space.Compact>
                                <Space.Addon>最多上传</Space.Addon>
                                <Form.Item name="attachment_max_count" noStyle rules={[{ required: true, message: '请输入总文件上传数量' }]}>
                                    <InputNumber placeholder="输入正整数" style={{ width: 100 }} min={1} max={10} precision={0} />
                                </Form.Item>
                                <Space.Addon>个</Space.Addon>
                            </Space.Compact>
                        </Form.Item>
                    )}

                    {currentFieldData && currentFieldData.cateId === 2 && (
                        <Form.Item label="单文件上传大小：" required>
                            <Space.Compact>
                                <Space.Addon>最大上传</Space.Addon>
                                <Form.Item name="attachment_max_file_size" noStyle rules={[{ required: true, message: '请输入单文件上传大小' }]}>
                                    <InputNumber placeholder="输入正整数" style={{ width: 100 }} min={1} precision={0} />
                                </Form.Item>
                                <Space.Addon>MB</Space.Addon>
                            </Space.Compact>
                        </Form.Item>
                    )}

                    {currentFieldData && (currentFieldData.cateId === 3 || currentFieldData.fieldName === 'person_case_info') && (
                        <Form.Item label="二级申报字段：">
                            {(currentFieldData.fieldName === 'person_case_info' ? personSecondField : secondField).map((item, index) => (
                                <Space key={item.field_name} style={{ display: 'flex' }} align="baseline">
                                    <Form.Item name={['children', index, 'checked']} valuePropName="checked" style={{ marginBottom: '10px' }}>
                                        <Checkbox style={{ width: '100px' }}>{item.field_display_name}</Checkbox>
                                    </Form.Item>
                                </Space>
                            ))}
                        </Form.Item>
                    )}
                </Form>
            </Modal>
        </div>
    );
};

export default FieldsList;
